// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components
import Login from './pages/Auth/Login/Login';
import Dashboard from './components/dashboard/Dashboard';
import ProtectedRoute from './ProtectedRoute';

// Utils
import { Auth } from './Utils/Auth';

// Styles
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Route de redirection par défaut */}
          <Route
            path="/"
            element={
              Auth.isLoggedIn() ?
                <Navigate to="/dashboard" replace /> :
                <Navigate to="/auth/login" replace />
            }
          />

          {/* Routes d'authentification */}
          <Route path="/auth/login" element={<Login />} />

          {/* Routes protégées du dashboard */}
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Route 404 */}
          <Route
            path="*"
            element={
              <div className="not-found">
                <h1>404 - Page non trouvée</h1>
                <p>La page que vous recherchez n'existe pas.</p>
                {Auth.isLoggedIn() ? (
                  <a href="/dashboard">Retour au dashboard</a>
                ) : (
                  <a href="/auth/login">Se connecter</a>
                )}
              </div>
            }
          />
        </Routes>

        {/* Notifications Toast */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </Router>
  );
}

export default App;